import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
var _excluded = ["id", "version"],
  _excluded2 = ["id", "version"],
  _excluded3 = ["issueId", "issueVersion"],
  _excluded4 = ["issueId", "issueVersion"],
  _excluded5 = ["issueVersion", "issueId"];
var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/issueManagerConnect.ts";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.filter.js";
import { buildRequestParams } from '@gmini/utils';

// eslint-disable-next-line import/no-cycle
import * as api from './index';
export function issueManagerConnect(fetchService) {
  api.User.fetchUserList.use(function (params) {
    return fetchService.post("/v1/user", params).then(api.User.fetchUserList.toPromise);
  });
  api.GTechIssue.uploadFile.use(function (_ref) {
    var formData = _ref.formData,
      issueId = _ref.issueId,
      issueVersion = _ref.issueVersion;
    return fetchService.uploadFile("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/file"), formData).then(api.GTechIssue.uploadFile.toPromise);
  });
  api.GTechIssue.startUploadFile.use(function (_ref2) {
    var issueId = _ref2.issueId,
      issueVersion = _ref2.issueVersion;
    return fetchService.post("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/file/start-upload"), {}).then(api.GTechIssue.startUploadFile.toPromise);
  });
  api.GTechIssue.addFile.use(function (_ref3) {
    var formData = _ref3.formData,
      issueId = _ref3.issueId,
      issueVersion = _ref3.issueVersion;
    return fetchService.uploadFile("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/file/add"), formData).then(api.GTechIssue.addFile.toPromise);
  });
  api.GTechIssue.deleteFile.use(function (_ref4) {
    var fileId = _ref4.fileId,
      issueId = _ref4.issueId,
      issueVersion = _ref4.issueVersion;
    return fetchService["delete"]("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/file/").concat(fileId)).then(api.GTechIssue.deleteFile.toPromise);
  });
  api.GTechIssue.downloadFile.use(function (_ref5) {
    var fileId = _ref5.fileId;
    return fetchService.get("/v1/issue/file/".concat(fileId)).then(api.GTechIssue.downloadFile.toPromise);
  });
  api.GTechIssue.fetchContentFiles.use(function (_ref6) {
    var issueId = _ref6.issueId,
      issueVersion = _ref6.issueVersion;
    return fetchService.get("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/file")).then(api.GTechIssue.fetchContentFiles.toPromise);
  });
  api.GTechIssue.create.use(function (body) {
    return fetchService.post("/v1/issue", body).then(api.GTechIssue.create.toPromise);
  });
  api.GTechIssue.fetchList.use(function (params) {
    return fetchService.post("/v1/issue/list", params).then(api.GTechIssue.fetchList.toPromise);
  });
  api.GTechIssue.fetchXlsx.use(function (params) {
    return fetchService.post("/v1/issue/list/xlsx", params, {
      blobContentTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    }).then(function (res) {
      var _contentDisposition$m;
      var blob = res.data;
      if (!(blob instanceof Blob)) {
        return res;
      }
      var contentDisposition = res.res.headers.get('Content-Disposition');
      //https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header
      var regex =
      // eslint-disable-next-line prefer-named-capture-group
      /filename(?:(?![\n;])[\s\S])*=[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(UTF\x2D[0-9]["']*)?((["'])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\.$|(?:(?![\n;])[\s\S])*)?/;
      var fileNameRaw = !!contentDisposition && ((_contentDisposition$m = contentDisposition.match(regex)) === null || _contentDisposition$m === void 0 ? void 0 : _contentDisposition$m[2]) || null;
      if (!fileNameRaw || !blob) {
        throw new Error('No filename or blob');
      }
      var fileName = decodeURIComponent(fileNameRaw);
      (function () {
        try {
          // Используем msSaveOrOpenBlob для браузеров типа Edge и IE
          if (window.navigator &&
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          window.navigator.msSaveOrOpenBlob) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ;
            window.navigator.msSaveOrOpenBlob(blob);
            return;
          }
          var objUrl = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();

          // Необходимо сделать задержку для Firefox
          setTimeout(function () {
            window.URL.revokeObjectURL(objUrl);
          }, 250);
        } catch (error) {
          console.error('error', error);
        }
      })();
      return _objectSpread(_objectSpread({}, res), {}, {
        data: {
          status: 'success',
          data: null
        }
      });
    }).then(api.GTechIssue.fetchXlsx.toPromise);
  });
  api.GTechIssue.fetch.use(function (_ref7) {
    var id = _ref7.id,
      version = _ref7.version;
    return fetchService.get("/v1/template/".concat(id, "/version/").concat(version)).then(api.GTechIssue.fetch.toPromise);
  });
  api.GTechIssue.fetchMostRecent.use(function (_ref8) {
    var id = _ref8.id;
    return fetchService.get("/v1/issue/".concat(id, "/most-recent")).then(api.GTechIssue.fetchMostRecent.toPromise);
  });
  api.GTechIssue.update.use(function (_ref9) {
    var id = _ref9.id,
      version = _ref9.version,
      body = _objectWithoutProperties(_ref9, _excluded);
    return fetchService.patch("/v1/issue/".concat(id, "/version/").concat(version), body).then(api.GTechIssue.update.toPromise);
  });
  api.GTechIssueTemplate.fetchList.use(function (params) {
    return fetchService.post("/v1/template/list", params).then(api.GTechIssueTemplate.fetchList.toPromise);
  });
  api.GTechIssueTemplate.fetch.use(function (_ref10) {
    var id = _ref10.id,
      version = _ref10.version;
    return fetchService.get("/v1/template/".concat(id, "/version/").concat(version)).then(api.GTechIssueTemplate.fetch.toPromise);
  });
  api.GTechIssueTemplate.fetchMostRecent.use(function (_ref11) {
    var id = _ref11.id;
    return fetchService.get("/v1/template/".concat(id, "/most-recent")).then(api.GTechIssueTemplate.fetchMostRecent.toPromise);
  });
  api.GTechIssueTemplate.update.use(function (_ref12) {
    var id = _ref12.id,
      version = _ref12.version,
      body = _objectWithoutProperties(_ref12, _excluded2);
    return fetchService.patch("/v1/template/".concat(id, "/version/").concat(version), body).then(api.GTechIssueTemplate.update.toPromise);
  });
  api.GTechIssueTemplate.remove.use(function (_ref13) {
    var id = _ref13.id,
      version = _ref13.version;
    return fetchService["delete"]("/v1/template/".concat(id, "/version/").concat(version)).then(api.GTechIssueTemplate.remove.toPromise);
  });
  api.GTechIssueTemplate.create.use(function (body) {
    return fetchService.post("/v1/template", body).then(api.GTechIssueTemplate.create.toPromise);
  });
  api.GTechIssue.fetchHistoryChanges.use(function (_ref14) {
    var issueId = _ref14.issueId,
      issueVersion = _ref14.issueVersion;
    return fetchService.get("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/history")).then(api.GTechIssue.fetchHistoryChanges.toPromise);
  });
  api.IssueComment.fetchList.use(function (_ref15) {
    var issueId = _ref15.issueId,
      issueVersion = _ref15.issueVersion,
      params = _objectWithoutProperties(_ref15, _excluded3);
    return fetchService.get("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/comment?").concat(buildRequestParams(_objectSpread({}, params)))).then(api.IssueComment.fetchList.toPromise);
  });
  api.IssueComment.create.use(function (_ref16) {
    var issueId = _ref16.issueId,
      issueVersion = _ref16.issueVersion,
      requestBody = _objectWithoutProperties(_ref16, _excluded4);
    return fetchService.post("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/comment"), requestBody).then(api.IssueComment.create.toPromise);
  });
  api.IssueComment.remove.use(function (_ref17) {
    var commentId = _ref17.commentId,
      issueVersion = _ref17.issueVersion,
      issueId = _ref17.issueId;
    return fetchService["delete"]("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/comment/").concat(commentId)).then(api.IssueComment.remove.toPromise);
  });
  api.GTechIssue.changeStatus.use(function (_ref18) {
    var issueVersion = _ref18.issueVersion,
      issueId = _ref18.issueId,
      body = _objectWithoutProperties(_ref18, _excluded5);
    return fetchService.post("/v1/issue/".concat(issueId, "/version/").concat(issueVersion, "/status"), {
      changeStatusBody: body
    }).then(api.GTechIssue.changeStatus.toPromise);
  });
  api.IssueStatus.fetchList.use(function () {
    return fetchService.get("/v1/issue/status").then(api.IssueStatus.fetchList.toPromise);
  });
  api.GTechIssue.fetchAllowedFilters.use(function (params) {
    return fetchService.get("/v1/issue/filter?".concat(buildRequestParams(params))).then(api.GTechIssue.fetchAllowedFilters.toPromise);
  });
  api.GTechIssueTemplate.fetchAllowedFilters.use(function (params) {
    return fetchService.get("/v1/template/filter?".concat(buildRequestParams(params))).then(api.GTechIssueTemplate.fetchAllowedFilters.toPromise);
  });
  api.Filters.fetchSavedFilters.use(function () {
    return fetchService.get("/v1/issue/filters").then(api.Filters.fetchSavedFilters.toPromise);
  });
  api.Filters.fetchSavedFilter.use(function (_ref19) {
    var id = _ref19.id;
    return fetchService.get("/v1/issue/filters/".concat(id)).then(api.Filters.fetchSavedFilter.toPromise);
  });
  api.Filters.deleteFilter.use(function (_ref20) {
    var id = _ref20.id;
    return fetchService["delete"]("/v1/issue/filters/".concat(id)).then(api.Filters.deleteFilter.toPromise);
  });
  api.Filters.updateFilter.use(function (_ref21) {
    var id = _ref21.id,
      filter = _ref21.filter;
    return fetchService.patch("/v1/issue/filters/".concat(id), filter).then(api.Filters.updateFilter.toPromise);
  });
  api.Filters.saveFilter.use(function (body) {
    return fetchService.post("/v1/issue/filters", body).then(api.Filters.saveFilter.toPromise);
  });
}